// extracted by mini-css-extract-plugin
export default {"optionRow":"OptionRow_optionRow__xiuGL","input":"OptionRow_input__on+2-","name":"OptionRow_name__4s4qd"};